import "@babel/polyfill";
let browsertest = () => {
  document.body.innerHTML =
    "<h5>Oei, onze website lijkt niet ondersteund door je browser. Zou je eens kunnen kijken in een andere (Chrome, Edge, Firefox)?</h5>";
};
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import lodash from "lodash";
import alertify from "alertify.js";

// can we use __proto__?
export const hasProto = '__proto__' in {}

// Browser environment sniffing
const inBrowser = typeof window !== 'undefined'
const inWeex = typeof WXEnvironment !== 'undefined' && !!WXEnvironment.platform
const weexPlatform = inWeex && WXEnvironment.platform.toLowerCase()
const UA = inBrowser && window.navigator.userAgent.toLowerCase()
const isIE = UA && /msie|trident/.test(UA)
const isIE9 = UA && UA.indexOf('msie 9.0') > 0
const isEdge = UA && UA.indexOf('edge/') > 0
const isAndroid = (UA && UA.indexOf('android') > 0) || (weexPlatform === 'android')
const isIOS = (UA && /iphone|ipad|ipod|ios/.test(UA)) || (weexPlatform === 'ios')
const isChrome = UA && /chrome\/\d+/.test(UA) && !isEdge
const isPhantomJS = UA && /phantomjs/.test(UA)
const isFF = UA && UA.match(/firefox\/(\d+)/)

var is_chrome = navigator.userAgent.indexOf('Chrome') > -1;
var is_explorer = navigator.userAgent.indexOf('MSIE') > -1;
var is_firefox = navigator.userAgent.indexOf('Firefox') > -1;
var is_safari = navigator.userAgent.indexOf("Safari") > -1;
var is_opera = navigator.userAgent.toLowerCase().indexOf("op") > -1;
if ((is_chrome)&&(is_safari)) { is_safari = false; }
if ((is_chrome)&&(is_opera)) { is_chrome = false; }

if (navigator.userAgent){
  if (isIE) browsertest()
  if (is_safari && !isIOS) browsertest()
} else {
  browsertest()
}

// firebase
import firebase from "firebase/app";
import "firebase/app";
import "firebase/firestore";
import "firebase/storage";

// vue components
import VueGlide from "vue-glide-js";
import "vue-glide-js/dist/vue-glide.css";
import VueProgressiveImage from "vue-progressive-image";
import VueProgressbar from "vue-progressbar";

import VueAnalytics from "vue-analytics";

import "./register-service-worker";
// filepond dynamically imported in ./filepond.js

let app = "";
Vue.config.productionTip = false;
var config = {
  apiKey: "AIzaSyBImHuCUAp73F4Z6BPK1fdIAJN2eeJZZs8",
  authDomain: "projectkind-ebc5d.firebaseapp.com",
  databaseURL: "https://projectkind-ebc5d.firebaseio.com",
  projectId: "projectkind-ebc5d",
  storageBucket: "projectkind-ebc5d.appspot.com",
  messagingSenderId: "804542783306"
};
firebase.initializeApp(config);

firebase.auth().onAuthStateChanged(() => {
  store.commit("setCurrentUser", firebase.auth().currentUser);
  if (!app) {
    app = new Vue({
      router,
      store,
      render: h => h(App)
    }).$mount("#app");
  }
});

Vue.prototype.$firebase = firebase;
Vue.prototype.$_ = lodash;
Vue.prototype.$alertify = alertify;

Vue.use(VueGlide);
Vue.use(VueProgressiveImage);

const isProd = process.env.NODE_ENV === "production";
Vue.use(VueAnalytics, {
  id: "UA-136317741-1",
  router,
  debug: {
    enabled: !isProd,
    sendHitTask: isProd
  }
});

const options = {
  color: "#42b983",
  failedColor: "#874b4b",
  autoRevert: true,
  inverse: false
};

Vue.use(VueProgressbar, options);
